/* eslint-disable react/no-array-index-key */

import { useState } from "react";
import PropTypes from "prop-types";
import cn from "classnames";

import { DashedLine, ChevronDownFill } from "@icons";
import { tagular } from "@cohesion/tagular";

export function Subnav({ activeDay = "", heading, handleClick, items }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleItemClick = (itemId, i) => {
    handleClick(itemId, i);
    tagular("click", {
      actionOutcome: "SELECT",
      outboundUrl: "null",
      webElement: {
        elementType: "NAV-BAR",
        location: "ITINERARYHEADER",
        name: "DAYS",
        position: "0",
        text: `DAY ${i + 1}`,
      },
    });
  };

  const handleMobileClick = (itemId, i) => {
    handleItemClick(itemId, i);
    setIsOpen(false);
  };

  return (
    <header
      className={cn("relative w-full bg-white transition-transform", {
        "shadow-md": !isOpen,
      })}
    >
      <div className="relative z-10 flex-wrap max-w-5xl px-2 py-2 bg-white md:flex md:justify-between md:items-center md:container md:px-0 2xl:max-w-7xl">
        <div className="flex items-center justify-between w-full md:flex-start md:w-auto">
          <h3 className="text-2xl tracking-wide uppercase font-rama font-black text-itinerary-blue-500">
            {heading}
          </h3>
          <button
            type="button"
            className="btn btn-primary flex items-center justify-between gap-2 min-w-[102px] md:hidden"
            onClick={() => setIsOpen(!isOpen)}
          >
            Day {items.findIndex(day => day.esid === activeDay) + 1 || 1}
            <ChevronDownFill />
          </button>
        </div>
        <nav className="hidden md:flex md:flex-wrap">
          <ul className="flex items-center gap-1 md:flex-wrap">
            {items.map((item, i) => (
              <li
                key={`desktop-${i}`}
                className={cn("flex items-center gap-1")}
              >
                <button
                  type="button"
                  className={cn(
                    "w-9 h-9 justify-center items-center rounded-full text-sm font-semibold",
                    item.esid === activeDay
                      ? "bg-blue border-blue text-white"
                      : "bg-blue-100 border-blue-100 hover:border-blue-300 text-black-400"
                  )}
                  onClick={() => handleItemClick(item.esid, i)}
                >
                  {i + 1}
                </button>

                {i + 1 !== items.length && (
                  <DashedLine className="w-10 text-center text-blue-200" />
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>

      {/**
       * Mobile drawer
       */}
      <div
        className={cn(
          "md:hidden md:invisible",
          "absolute top-full left-0 w-full bg-white py-2 transition-all -z-10 shadow-lg",
          isOpen ? "opacity-100" : "opacity-0 -translate-y-1/2"
        )}
      >
        <div className="pt-4 border-t border-black-100">
          <nav>
            <ul className="flex flex-wrap justify-center gap-x-10 gap-y-4">
              {items.map((item, i) => (
                <li
                  key={`mobile-${i}`}
                  className="flex items-center justify-center"
                >
                  <button
                    type="button"
                    className={cn(
                      "w-10 h-10 flex justify-center items-center rounded-full text-sm font-semibold",
                      item.esid === activeDay
                        ? "bg-blue border-blue text-white"
                        : "bg-blue-100 border-blue-100 hover:border-blue-300 text-black-400"
                    )}
                    onClick={() => handleMobileClick(item.esid, i)}
                  >
                    {i + 1}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
}

Subnav.propTypes = {
  heading: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({ esid: PropTypes.string.isRequired })
  ).isRequired,
  activeDay: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
};
